var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-main"},[_c('div',{staticClass:"card"},[_c('div',{staticStyle:{"padding-right":"0"}},[_c('div',{staticClass:"pt-2"},[_c('b-button',{staticClass:"btn title btn-style",style:({
            borderBottom:
              _vm.viewTypeCase === 'newCase' ? '2px solid #4DE594' : 'none',
            color: _vm.viewTypeCase === 'newCase' ? '#4DE594' : '',
          }),on:{"click":function($event){_vm.viewTypeCase = 'newCase'}}},[_vm._v("Casos novos")]),_vm._v(" "),_c('b-button',{staticClass:"btn title btn-style",style:({
            borderBottom:
              _vm.viewTypeCase === 'treatedCase' ? '2px solid #4DE594' : 'none',
            color: _vm.viewTypeCase === 'treatedCase' ? '#4DE594' : '',
          }),on:{"click":function($event){_vm.viewTypeCase = 'treatedCase'}}},[_vm._v("Casos tratados")])],1)])]),_vm._v(" "),(_vm.viewTypeCase === 'newCase')?[_c('NewCases')]:[_c('TreatedCases')]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02b1e9f6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/molecules/highcharts/monitoring-treatment/index.vue
// module id = null
// module chunks = 